var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spiderWrapper"},[_c('div',{staticClass:"spiderWeb"},[_c('svg-sprite',{attrs:{"width":"48","height":"48","icon-id":"spider-web-trap","halloween":""}})],1),_c('div',{staticClass:"spider"},[_c('svg-sprite',{attrs:{"width":"48","height":"48","icon-id":"spider","halloween":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }